module.exports = __webpack_public_path__ + "static/img/icon_help@2x.3d045234.png";